import React, { FC } from 'react'
import { Modal } from 'react-bootstrap'

interface InputBatchModalProps {
    show: boolean
    onHide: () => void
    productionData: any
}

const InputBatchModal: FC<InputBatchModalProps> = ({ show, onHide, productionData }) => {
    const calculateTotalPackagingUnits = () => {
        if (!productionData?.packingUnit) return 0
        return Object.values(productionData.packingUnit).reduce((sum: number, value: any) => {
            return sum + parseFloat(value || 0)
        }, 0)
    }

    const totalPackagingUnits = calculateTotalPackagingUnits()
    const batchInfo = productionData?.batchInfo || []

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Input Batch Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: '20px', fontSize: '16px', fontWeight: '600' }}>
                    Total number of input batches consumed = {totalPackagingUnits.toFixed(2)}
                </div>

                <div className="table-responsive">
                    <table
                        className="table align-middle table-row-dashed fs-6 gy-5"
                        style={{ width: '100%', borderCollapse: 'collapse' }}
                    >
                        <thead>
                            <tr style={{
                                backgroundColor: '#333333',
                                color: 'white',
                                fontFamily: 'Inter, Arial, sans-serif',
                                fontSize: '12.32px',
                                fontWeight: '600',
                                textTransform: 'uppercase',
                            }}>
                                <th style={{
                                    padding: '15px',
                                    textAlign: 'left',
                                    borderBottom: '1px dotted #dee2e6',
                                }}>
                                    Unit Number
                                </th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>
                                    Batch id
                                </th>
                                <th style={{ padding: '15px', textAlign: 'left', borderBottom: '1px dotted #dee2e6' }}>
                                    Source
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {batchInfo && batchInfo.length > 0 ? (
                                batchInfo.map((batch: any, index: number) => (
                                    <tr key={index} style={{ backgroundColor: 'white' }}>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {index + 1}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {batch.orderId || 'N/A'}
                                        </td>
                                        <td style={{ padding: '20px 12px', borderBottom: '1px dotted #dee2e6' }}>
                                            {batch.type || 'N/A'}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={3} className="text-center" style={{ padding: '20px 12px', color: "gray" }}>
                                        No batch information found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default InputBatchModal